import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useCallback } from "react";
import { ALL_OPEN_ORDERS_WITH_MISSIONS, JOIN_ORDER_AND_MISSION } from "../../../../common/queries";
import useOrderMissionDetailsColumns from "../../../../hooks/useOrderMissionDetailsColumns";
import EntityJoinTable from "../../../common/tables/EntityJoinTable";

export default function OpenOrdersSection() {
  const { t } = useTranslation();
  const { tabId } = useParams();
  const navigate = useNavigate();

  const columns = useOrderMissionDetailsColumns();

  const onRowClick = useCallback((params, ev) => {
    navigate(!tabId ? `./open/${params.row.missionId}/${params.id}` : `./${params.row.missionId}/${params.id}`, { relative: "path" });
  }, [navigate, tabId]);

  return (
    <EntityJoinTable
      tableId="open_orders_section"
      type="Order"
      join={JOIN_ORDER_AND_MISSION}
      onRowClick={onRowClick}
      columns={columns}
      filter={ALL_OPEN_ORDERS_WITH_MISSIONS}
      emptyStateTitle={t("openOrders:emptyStateTitle")}
      emptyStateDescription={t("openOrders:emptyStateDescription")}
      xs={12}
    />
  );
}

